import React from 'react';
import ContentLoader from "react-content-loader";

const SelectSessionsLoader = (props:any) => {
    return (
        <ContentLoader
            speed={2}
            width={1561}
            height={1000}
            style={{marginTop:'-120px'}}
            viewBox="0 0 1267 600"
            backgroundColor="#f3f3f3"
            foregroundColor="#effeb4"
            {...props}
        >
            <rect x="0" y="0" rx="8" ry="8" width="80" height="80" />
            <rect x="90" y="0" rx="8" ry="8" width="150" height="30" />
            <rect x="90" y="40" rx="8" ry="8" width="200" height="40" />

            <rect x="0" y="100" rx="8" ry="8" width="80" height="80" />
            <rect x="90" y="100" rx="8" ry="8" width="150" height="30" />
            <rect x="90" y="140" rx="8" ry="8" width="200" height="40" />

            <rect x="0" y="200" rx="8" ry="8" width="80" height="80" />
            <rect x="90" y="200" rx="8" ry="8" width="150" height="30" />
            <rect x="90" y="240" rx="8" ry="8" width="200" height="40" />

        </ContentLoader>
    );
};

export default SelectSessionsLoader;
